exports.install = function (Vue, options) {
    Vue.prototype.config = config;
};